import { Document } from '@app/types/document';
import { getDocumentDownloadLink } from '@app/page-fragments/dashboard/documents/components/DocumentDownloadLink';
import { getFormattedMessage } from '@app/components/formatted-message/FormattedMessage';
import { ONE_MB } from './file';
import { TableHeaderConfig, TableHeadersMap } from '@app/types/table';
import {
  documentDateTransformer,
  getDocumentActions,
  getFormattedCurrency,
  getDocumentStatus,
  documentUTCDateTransformer,
} from '@app/utils/document';

export const DEFAULT_DOCUMENT_TABLE_PAGE_SIZE = 10;

export const INSURANCE_DOC_UPLOAD_FILE_TYPES = ['pdf', 'jpg', 'jpeg', 'png'];

export const MAX_DRIVERS_LICENSE_SIZE_MB = 15 * ONE_MB;
export const MAX_DRIVERS_LICENSE_SIZE_MB_STRING = '15MB';

export const documentTableHeadersMap = {
  document: {
    id: 'document',
    label: getFormattedMessage({ data: { id: 'documents.headers.document' } }),
    dataLookupKeys: ['original_file_name'],
  },
  coverageAmount: {
    id: 'coverageAmount',
    label: getFormattedMessage({ data: { id: 'documents.headers.coverageAmount' } }),
    dataLookupKeys: ['extended_data', 'total_coverage_amount'],
    transformer: getFormattedCurrency,
  },
  validFrom: {
    id: 'validFrom',
    label: getFormattedMessage({ data: { id: 'documents.headers.validFrom' } }),
    dataLookupKeys: ['valid_from'],
    transformer: documentUTCDateTransformer,
    isSortable: true,
  },
  expiration: {
    id: 'expiration',
    label: getFormattedMessage({ data: { id: 'documents.headers.expiration' } }),
    dataLookupKeys: ['valid_until'],
    transformer: documentUTCDateTransformer,
    isSortable: true,
  },
  dateAdded: {
    id: 'dateAdded',
    label: getFormattedMessage({ data: { id: 'documents.headers.dateAdded' } }),
    dataLookupKeys: ['date_created'],
    transformer: documentDateTransformer,
    isSortable: true,
    isDefaultSort: true,
  },
  status: {
    id: 'status',
    label: getFormattedMessage({ data: { id: 'documents.headers.status' } }),
    dataLookupKeys: ['status_id'],
    transformer: getDocumentStatus,
  },
  actions: {
    id: 'actions',
    label: getFormattedMessage({ data: { id: 'documents.headers.actions' } }),
    transformer: getDocumentActions,
  },
} satisfies TableHeadersMap;

export const documentCompactTableHeadersMap = {
  ...documentTableHeadersMap,
  view: {
    id: 'view',
    label: getFormattedMessage({ data: { id: 'documents.headers.view' } }),
    transformer: (data: Document) => getDocumentDownloadLink(data, 'view'),
  },
} satisfies TableHeadersMap;

export const documentTableHeaders: TableHeaderConfig[] = Object.values(documentTableHeadersMap);
export const documentCompactTableHeaders: TableHeaderConfig[] = Object.values(documentCompactTableHeadersMap);
